const get = (key: string, _default?: string) => {
    return (process.env[key] || _default);
};

let protocol = window.location.protocol;
let host = window.location.hostname;
if (host === "localhost") {
    host = "netribe-ztp.test";
}

const base = `${protocol}//${host}`;
export const config = {
    lang: (window['lang'] || "en"),
    locales: (window['locales'] || []),
    api: {
        base_url: get("REACT_APP_API_BASEURL", `${base}`),
        mock_url: get("REACT_APP_API_MOCKURL", `${base}/debug/mock`),
    },
};


// WEBPACK FOOTER //
// ./src/config.ts